export function dayRateDisplay(val) {
  const hasDecimal = val - Math.floor(val) !== 0;
  return hasDecimal ? val.toFixed(2) : val.toString();
}
